/**
 * Utility function to parse error messages from API responses
 * @param {Error} error - The error object from axios catch block
 * @param {string} defaultMessage - Default message to show if no error detail is found
 * @returns {string} - Formatted error message
 */
export const getErrorMessage = (error, defaultMessage = 'An error occurred') => {
  const detail = error?.response?.data?.detail;
  
  if (Array.isArray(detail)) {
    // Handle array of strings (from backend error messages)
    if (typeof detail[0] === 'string') {
      return detail.join(', ');
    }
    // Handle array of objects with msg property
    return detail.map(d => d.msg).join(', ');
  }
  
  if (typeof detail === 'object') {
    return JSON.stringify(detail);
  }
  
  return detail || defaultMessage;
};
